import { consoleAdapter } from "@/shared/logger/adapters/consoleAdapter";
import type { Level, LoggerAdapter } from "@/shared/logger/types";

let adapter: LoggerAdapter = consoleAdapter;
let minLevel: Level = "debug";

const order: Record<Level, number> = { debug: 0, info: 1, warn: 2, error: 3 };

export function configureLogger(opts: { adapter?: LoggerAdapter; minLevel?: Level }): void {
  if (opts.adapter) adapter = opts.adapter;
  if (opts.minLevel) minLevel = opts.minLevel;
}

function emit(level: Level, message: string, context?: Record<string, unknown>): void {
  if (order[level] < order[minLevel]) return;
  adapter.log({
    level,
    message,
    timestamp: new Date(),
    ...(context !== undefined ? { context } : {}),
  });
}

export const logger = {
  debug: (m: string, c?: Record<string, unknown>) => emit("debug", m, c),
  info: (m: string, c?: Record<string, unknown>) => emit("info", m, c),
  warn: (m: string, c?: Record<string, unknown>) => emit("warn", m, c),
  error: (m: string, c?: Record<string, unknown>) => emit("error", m, c),
};
